import React from 'react';
import { ProFormTextArea } from '@ant-design/pro-form';
import { DatePicker, Form } from 'antd';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import ProForm from 'components/layout/ProForm';
import { FormUpload } from 'components/input';

const ExtensionForm = ({
  loading,
  form,
  onFinish,
  initialValues,
  projectFrozen,
}) => {
  const { projectId } = useParams();
  return (
    <ProForm
      loading={loading}
      form={form}
      initialValues={initialValues}
      onFinish={onFinish}
      disabled={projectFrozen}
    >
      <Form.Item
        width="xl"
        name="newCompletionDate"
        label="New Completion Date"
        placeholder="new completion date"
        rules={[
          { required: true, message: 'Please enter New Completion Date!' },
        ]}
      >
        <DatePicker
          className="ant-input pro-field pro-field-xl"
          disabled={projectFrozen}
        />
      </Form.Item>
      <FormUpload
        disabled={projectFrozen}
        maxCount={1}
        name="progressReport"
        label="Progress Report"
        rules={[{ required: true, message: 'Please upload file!' }]}
        projectId={projectId}
        subFolder="EXTENSION"
      />
      <FormUpload
        disabled={projectFrozen}
        maxCount={5}
        name="supplements"
        label="Supplement(s) (max. 5)"
        projectId={projectId}
        subFolder="EXTENSION"
        multiple
      />
      <ProFormTextArea
        disabled={projectFrozen}
        width="xl"
        name="justification"
        label="Justification"
        placeholder="justification"
        rules={[{ required: true, message: 'Please enter justification!' }]}
      />
    </ProForm>
  );
};

ExtensionForm.defaultProps = {
  initialValues: {},
  loading: false,
  projectFrozen: false,
};

ExtensionForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  projectFrozen: PropTypes.bool.isRequired,
};

export default ExtensionForm;
